export const SITE_TYPE = "IMWEB";

export const IMWEB_PAGE = {
  LOGIN: { target: `${SITE_TYPE}:LOGIN`, url: "/login" },
  SIGNUP: { target: `${SITE_TYPE}:SIGNUP`, url: "/site_join_agree" },
  MY_PAGE: { target: `${SITE_TYPE}:MY_PAGE`, url: "/shop_mypage" },
  CART: { target: `${SITE_TYPE}:CART`, url: "/shop_cart" },
  // 비밀번호 찾기는 팝업형태로 제공됨
} as const;
